/**
 * Hook to access settings from the settings store.
 * Provides a Vuexy-compatible API for accessing settings.
 */

import { useSettings as useSettingsStore } from '../../store/settingsStore';

/**
 * Hook to access and update settings.
 * Matches Vuexy's useSettings pattern.
 */
export const useSettings = () => {
  return useSettingsStore();
};
